export default __webpack_public_path__ + "static/media/support_icon.d58ea3f5.svg";